export const INSIGHT_TABS = {
    categories: 'CATEGORIES',
    search: 'SEARCH',
    dashboard: 'DASHBOARD'
}
